import Vue from 'vue';
import Vuex from 'vuex';
import {AxiosWebApiClient} from '@/core/webapi/WebApiClient';
import { CoreState } from '@/models/core/CoreState';
import LoggedInternalLayout from '@/models/layout/LoggedInternalLayout';

Vue.use(Vuex);

const Store = new Vuex.Store({
  state: {
    locale: 'ru',
    apiClient: new AxiosWebApiClient(`${process.env.VUE_APP_API_HOST}`),
    user: new CoreState(),
    layout: new LoggedInternalLayout(),
  },
  mutations: {
    changeLocale(state, locale = 'ru') {
      state.locale = locale;
    },
  },
  actions: {
  },
  modules: {
  },
});

export default Store;
